import store from '@/store';
import Vue from 'vue';

Vue.filter('asType', (id) => store.getters.say[`types_${id}`]);
